/**
 * Jerarquía de roles compartida por el frontend.
 *
 * `super` atraviesa CUALQUIER gate de rol (igual que `requireRole` del
 * backend Node): "super siempre debería hacer lo de admin y más" es
 * estructural. El resto de roles se validan por igualdad contra la lista —
 * `admin` y `supervisor` son ramas distintas a propósito.
 */
export function passesRoleGate(userRole: string | null | undefined, allowedRoles: string[]): boolean {
  const role = userRole?.toLowerCase();
  if (!role) return false;
  if (role === 'super') return true;
  return allowedRoles.some((r) => r.toLowerCase() === role);
}
